<div class="tile-padding">
  <h3 class="header-tile">{{actionDataParams.header}}</h3>

  <app-data-table
    [columns]="columns"
    [data]="rows"
    [emptyMessage]="nodataStr"
    [serverSide]="serverSide"
    [totalCount]="totalCount"
    [sortField]="sortField"
    [sortDir]="sortDir"
    [loading]="loading"
    [tableId]="tableId"
    (pageChange)="onPageChange($event)"
    (sortChange)="onSortChange($event)"
    (rowClick)="onDataclicked($event)">

    <ng-template appColumnCell="student" let-element>
      <span class="tw:w-full tw:items-center tw:flex">
        <div class="student-group-icon-container tw:mr-2 tw:float-left"
          [ngClass]="{'single-student-icon': !element.isGroupPlacement,
                        'group-one-student-icon': element.isGroupPlacement && element.groupSize == 1,
                        'group-two-student-icon': element.isGroupPlacement && element.groupSize == 2,
                        'group-three-student-icon': element.isGroupPlacement && element.groupSize == 3,
                        'group-multiple-student-icon': element.isGroupPlacement && element.groupSize > 3}"></div>{{element.isGroupPlacement == true ? element.groupName : element.studentName}}
      </span>
    </ng-template>

    <ng-template appColumnCell="brand" let-element>
      {{element.companyId | brandShortCode: brands}}
    </ng-template>

    <ng-template appColumnCell="task" let-element>
      {{element.actionType.description}}
      @if (filtersEnabled && !displayall && element.isOverdue) {
        <span class="action-overdue-badge tw:ml-2 tw:rounded tw:px-1 tw:text-xs tw:font-semibold tw:text-red-600" title="Open for more than {{overdueDays}} days">Overdue</span>
      }
    </ng-template>

    <ng-template appColumnCell="completed" let-element>
      @if (element.completedUtc) {
        <span class="action-completed">{{element.completedBy}}<br />{{element.completedUtc | date:'dd/MM/yyyy HH:mm'}}</span>
      } @else {
        <span class="action-open tw:text-green-600">Open</span>
      }
    </ng-template>
  </app-data-table>
</div>
